if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('.product-form__submit-label, span');
        this.soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
        this.spinner = this.querySelector('.loading__spinner');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.isSubmitting = false;
        this.error = false;

        if (document.querySelector('cart-drawer')) {
          this.submitButton?.setAttribute('aria-haspopup', 'dialog');
        }
      }

      async onSubmitHandler(event) {
        event.preventDefault();

        if (!this.form || !this.submitButton || this.isSubmitting) return;
        if (
          this.submitButton.getAttribute('aria-disabled') === 'true' ||
          this.submitButton.hasAttribute('disabled')
        ) {
          return;
        }

        this.isSubmitting = true;
        this.error = false;

        this.handleErrorMessage();
        this.resetInlineStates();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.spinner?.classList.remove('hidden');

        try {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);

          if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);

            if (typeof this.cart.setActiveElement === 'function') {
              this.cart.setActiveElement(document.activeElement);
            }
          }

          config.body = formData;

          const response = await fetch(`${routes.cart_add_url}`, config);
          const responseJson = await response.json();

          if (responseJson.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: responseJson.errors || responseJson.description,
              message: responseJson.message,
            });

            this.handleErrorMessage(
              responseJson.description || responseJson.message || window.variantStrings.unavailable
            );

            if (this.soldOutMessage && this.submitButtonText) {
              this.submitButtonText.classList.add('hidden');
              this.soldOutMessage.classList.remove('hidden');
            }

            this.submitButton.setAttribute('aria-disabled', 'true');
            this.error = true;
            return;
          }

          if (!this.cart) {
            window.location.href = window.routes?.cart_url || routes.cart_url || '/cart';
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: responseJson,
          });

          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                window.setTimeout(() => {
                  this.safeRenderCart(responseJson);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.safeRenderCart(responseJson);
          }
        } catch (error) {
          console.error('[product-form] add to cart failed', error);
          this.handleErrorMessage(window.variantStrings.unavailable);
          this.error = true;
        } finally {
          this.isSubmitting = false;
          this.submitButton?.classList.remove('loading');
          this.spinner?.classList.add('hidden');

          if (this.cart?.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.submitButton?.hasAttribute('disabled')) {
            this.submitButton?.removeAttribute('aria-disabled');
          }
        }
      }

      safeRenderCart(parsedState) {
        if (!this.cart || typeof this.cart.renderContents !== 'function') {
          window.location.href = window.routes?.cart_url || routes.cart_url || '/cart';
          return;
        }

        try {
          this.cart.renderContents(parsedState);
        } catch (error) {
          console.error('[product-form] cart render failed, redirecting to cart', error);
          window.location.href = window.routes?.cart_url || routes.cart_url || '/cart';
        }
      }

      resetInlineStates() {
        this.submitButtonText?.classList.remove('hidden');
        this.soldOutMessage?.classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        this.resetInlineStates();

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}